import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import * as React from 'react';
import { TranslationProvider } from './TranslationContext';
import { setLang } from '@ds/base';
import { useHtmlLang } from '../useHtmlLang';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AppTranslationProvider = function AppTranslationProvider(props) {
  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loadedLocale = _React$useState2[0],
      setLoadedLocale = _React$useState2[1];

  var _React$useState3 = React.useState(function (textId) {
    return textId;
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      translateFn = _React$useState4[0],
      setTranslateFn = _React$useState4[1];

  var lang = useHtmlLang() || 'en';

  if (loadedLocale !== lang) {
    props.fetchTranslate(lang).then(function (fn) {
      setLoadedLocale(lang);
      setTranslateFn(function () {
        return fn;
      });
    }).catch(function (e) {
      setLang(loadedLocale);
    });
  }

  return ___EmotionJSX(TranslationProvider, {
    translate: translateFn
  }, props.children);
};